import * as marietta from "../../..";
import { Dialog } from "../../../core/view";
import { LiDARData } from "../../../network/LiDARData";
import { BUILDING_TYPE_HOUSE, BUILDING_TYPE_MANSION } from '../../../../marietta/webcad/Constants';
import Main from "../../../../main";
import { BuildingDocument } from "../../../LiDAR/commands";
import { ThreeView } from "../../../view3d/webcad";

export class LiDARLogingDialog extends Dialog {

    // 新規作成かどうか
    private isNewPlan: boolean = false;

    constructor(draggable: boolean) {
        super(draggable);
    }

    /**
     * HTML生成
     */
    buildContent() {
        let id: string | null, title: string | null, contents: string | null, footer: string | null;

        //ダイアログのコンテンツ生成
        id = 'LiDARLogingDialog';

        switch (marietta.webcad.WebCADGlobal.language) {
            case "jp":
                title = 'LiDARデーターの読み込み';
                break;
            default:
                title = 'Loading LiDAR data';
                break;
        }

        contents = '<div class="LiDARLogingDialog">';
        contents += '<div class="explanationBody">';
        contents += '<p class="notationMessage"><span class="jp">LiDARデーターを読み込みますか。</span><span class="en">Do you want to read in LiDAR data?</span></p>\n';
        contents += '</div>';
        contents += '</div>';

        footer = '<button id="btnCancel"><span class="jp">キャンセル</span><span class="en">Cancel</span></button>';
        footer += '<button id="btnStart"><span class="jp">読み込み</span><span class="en">Start</span></button>';

        this.createDialog(id, title, contents, footer);

        id = title = contents = footer = null;

        document.querySelector('#LiDARLogingDialog #btnStart')?.addEventListener('click', this.onStartButtonClicked);
        document.querySelector('#LiDARLogingDialog #btnCancel')?.addEventListener('click', this.close);
    }

    private setMode() {
        //起動用暫定処理--------------------------↓
        // 建築モードの更新
        // marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType = BUILDING_TYPE_MANSION;
        // アイテムメニュー初期表示
        marietta.webcad.WebCADGlobal.itemMenu.initView();
        //起動用暫定処理--------------------------↑
    }
    /**
     * OKボタンがクリックされた
     */
    private onStartButtonClicked = () => {
        this.closeEvent();
        this.setMode();
        ThreeView.get().buildingDocument =  new BuildingDocument();
        // 物件ドキュメント取得 -> LiDARデータ取得
        const res = ThreeView.get().buildingDocument.execute();
        res.then(async () => await new LiDARData().json());
    }

    /**
     * キャンセルボタンがクリックされた
     */
    // onCancelButtonClicked = (e: MouseEvent) => {
    //     e.preventDefault();
    //     this.close();
    // }

    close = () => {
        this.closeEvent();

        // 新規作成ボタンから呼び出された場合
        if (this.isNewPlan == true) {
            marietta.webcad.WebCADGlobal.showConfirmDialog(marietta.webcad.collection.WebCADMessages.getText('NOTICE_CLOSE_PLAN_AND_NEW'), '', Main.newPlan);
            return;
        }

        Main.setBuildingStyleFromQueryParameterCondition();
    }

    closeEvent() {
        super.closeEvent();
    }
}
